import NavBar from '../components/NavBar'
import HeroSection from '../components/OurProductVetri/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/OurProductVetri/ProcessSection'
import TechStackMarquee from '../components/OurProductVetri/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const OurProductVetri = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default OurProductVetri